import graphql from "../../graphql";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    wishlist: {
      state: false,
      loading: false,
    },
    availableOn: null,
    deletedAt: null,
    VendorIntroVideo: {
      show: false,
    },
  },
  getters: {
    onWishlist: state => state.wishlist.state,
    availableOn: state => state.availableOn,
    deletedAt: state => state.deletedAt,
    wishlistLoading: state => state.wishlist.loading,
    showVendorIntroVideo: state => {
      return state.VendorIntroVideo.show;
    },
  },
  actions: {
    fetchProductData: (context, id) => {
      graphql.query({ query: productQuery(), variables: { id } }).then(response => {
        let product = response.data.product;
        context.commit("setProductOnWishlist", product.onWishlist);
        context.commit("setProductAvailableOn", product.availableOn);
        context.commit("setProductDeletedAt", product.deletedAt);
      });
    },
    setProductOnWishlist: (context, { url, translations }) => {
      context.commit("setWishlistLoading", true);
      return axios
        .put(url, { format: "json" })
        .then(response => {
          context.commit("setProductOnWishlist", true);
          flash("notice", response.data.notice, context.commit);
        })
        .catch(() => {
          flash("error", translations["error"], context.commit);
        })
        .finally(() => {
          context.commit("setWishlistLoading", false);
        });
    },
    setVendorIntroShow: (context, data) => {
      context.commit("setVendorIntroVideoShow", data);
    },
  },
  mutations: {
    setProductOnWishlist: (state, bool) => {
      state.wishlist.state = bool;
    },
    setProductAvailableOn: (state, timestamp) => {
      state.availableOn = timestamp;
    },
    setProductDeletedAt: (state, timestamp) => {
      state.deletedAt = timestamp;
    },
    setWishlistLoading: (state, bool) => {
      state.wishlist.loading = bool;
    },
    setVendorIntroVideoShow: (state, bool) => {
      state.VendorIntroVideo.show = bool;
    },
  },
};

const productQuery = () => `
  query Product($id: ID!){
    product(id: $id){
      onWishlist
      availableOn
      deletedAt
    }
  }
`;

const flash = (type, message, commit) =>
  commit("flashMessages/setMessages", [[type, message]], {
    root: true,
  });
